/**
 * Limits and options for the create chat pop-ups (FR60 screens 60.1 – 60.4).
 */

import { NEW_CHAT_CONTACT_PERMISSION_DENIED, NEW_GROUP_CONTACT_PERMISSION_DENIED } from '../../Helpers/Chat/Constant';
import { DISAPPEAR_OPTIONS } from '../../Helpers/Chat/disappearOptions';

export {
    CONTACT_LOAD_THRESHOLD,
    CONTACT_PAGE_SIZE,
    SEARCH_DEBOUNCE_MS,
    SEARCH_MAX_LENGTH,
} from '../../Components/WebChat/Common/ContactList/constants';

export const CREATE_CHAT_FLOW = {
    CONTACT_LIST: 'contactList',
    NEW_GROUP: 'newGroup',
};

// Shown instead of a flow when contact access is denied, as the old screens did.
export const CREATE_CHAT_PERMISSION_DENIED = {
    [CREATE_CHAT_FLOW.CONTACT_LIST]: NEW_CHAT_CONTACT_PERMISSION_DENIED,
    [CREATE_CHAT_FLOW.NEW_GROUP]: NEW_GROUP_CONTACT_PERMISSION_DENIED,
};

export const USERNAME_MAX_LENGTH = 255;
export const GROUP_NAME_MAX_LENGTH = 256;
export const GROUP_DESCRIPTION_MAX_LENGTH = 300;

// Days the server accepts as msgDisappear; 0 turns the setting off.
export const DISAPPEARING_OFF = 0;
// Same labels as the chat info, from the shared list.
export const DISAPPEARING_DURATIONS = DISAPPEAR_OPTIONS.filter(option => option.days !== DISAPPEARING_OFF);
export const DISAPPEARING_DEFAULT_DAYS = 7;

export const GROUP_CREATE_ERROR = {
    BLOCKED_YOU: 'E19',
    BLOCKED_BY_ADMIN: 'E20',
};

export const CONTACT_ADD_ERROR = {
    PHONE_IN_CONTACTS: 'E16',
    USER_NOT_FOUND: 'E18',
    CANNOT_ADD_YOURSELF: 'E48',
};
